var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"infoboard-title\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Location",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":33},"end":{"line":2,"column":59}}}))
    + "</div>\n    <div class=\"row field-content\">\n        <div class=\"col-sm-4 field-label\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Latitude",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":4,"column":42},"end":{"line":4,"column":68}}}))
    + "</div>\n        <div class=\"col-sm-8 field-value\">"
    + alias2(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"location") : depth0)) != null ? lookupProperty(stack1,"latitude") : stack1), depth0))
    + "</div>\n    </div>\n    <div class=\"row field-content\">\n        <div class=\"col-sm-4 field-label\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Longitude",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":42},"end":{"line":8,"column":69}}}))
    + "</div>\n        <div class=\"col-sm-8 field-value\">"
    + alias2(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"location") : depth0)) != null ? lookupProperty(stack1,"longitude") : stack1), depth0))
    + "</div>\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/stores-location.hbs
// module id = 2Pyg
// module chunks = 1